import { Box, Grid, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import { useCallback } from "react";
import { CalculateByField } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";

interface Props {
  calculateBy: CalculateByField | undefined;
  disabled?: boolean;
  onChange: (calculateBy: CalculateByField) => void;
}

export default function CalculateByFieldControl({ calculateBy, disabled, onChange }: Props) {
  const handleCalculateByChange = useCallback(
    (_: React.MouseEvent<HTMLElement>, newCalculateBy: CalculateByField | null) => {
      if (newCalculateBy !== null) onChange(newCalculateBy);
    },
    [onChange]
  );

  return (
    <Grid container sx={{ alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", width: "100%" }}>
      <Box sx={{ display: "flex", flexGrow: 1, flexBasis: "30%" }}>
        <Typography noWrap>Calculate Amount By</Typography>
      </Box>
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={calculateBy}
        disabled={disabled}
        fullWidth
        sx={{ width: 208 }}
        onChange={handleCalculateByChange}
      >
        {availableCalculateByFields.map((item) => (
          <Tooltip key={item.field} title={item.title} arrow disableInteractive>
            <ToggleButton value={item.field} sx={{ py: 0.3, fontWeight: 400, textWrap: "nowrap" }}>
              {toCalculateByCaption(item.field)}
            </ToggleButton>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
    </Grid>
  );
}

const availableCalculateByFields = [
  { field: CalculateByField.Pcy, title: "Position Currency" },
  { field: CalculateByField.Lcy, title: "Local Currency" },
  { field: CalculateByField.AdditionalLcy, title: "Additional Reporting Currency" },
];

const toCalculateByCaption = (calcBy: CalculateByField): string => {
  switch (calcBy) {
    case CalculateByField.Lcy:
      return "LCY";
    case CalculateByField.Pcy:
      return "PCY";
    case CalculateByField.AdditionalLcy:
      return "ACY";
    case CalculateByField.Shares:
      return "Shares";
    case CalculateByField.Scy:
      return "Source Amount";
    default:
      return "";
  }
};
